<template>
    <div class="m-index" :class="{'menu-collapsed': collapsed,'menu-expanded':!collapsed }" id="layout">
        <vheader :collapsed="collapsed"  @show="showHandle" @hide='hidetion' @collapse="collapse" @showMail="showMail" ref="headers"/>
        <!--左侧导航-->
        <div class="asideNav">
            <div class="logo" :class="collapsed ? 'logo-collapse': '' ">
                <router-link to="/home" >
                    <img src="../../assets/img/logo.png" />
                </router-link>
            </div>
            <menu-left :menus="menus" ref="navs" :collapseTip="collapsed" @isShow="hideMail"></menu-left>
        </div>
        <!--消息列表-->
        <mail-side v-if='isMail' @hide="hideMail"></mail-side>
        <el-scrollbar wrapClass="scrollView" style="height: 100%;" ref="conScroll" id="content">
            <div class="content-container clearfix">
                <transition name="custom-classes-transition" enter-active-class="pageFadeInRight">
                    <router-view @refrashStatus="refrashStatus"></router-view>
                </transition>
                <to-top v-if="createTop"></to-top>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import { menuLists } from '@/router/routeList'
import menuLeft from './menuLeft'
import API from '@/fetch/api'
import mailSide from '@/components/mailSide'
import vheader from '@/components/vheader'
import { GetInfo } from '@/fetch/com'
import toTop from '@/components/toTop'
import { mapState, mapMutations } from 'vuex'
import * as access from '@/config/access'
import { checkStatus } from '@/common/util/constans' 

export default {
    name: 'layout',
    data() {
        return {
            auth: [],
            collapsed: false,
            isMail: false,
            createTop: true,
            menus: menuLists, //菜单
            checkStatus,
        }
    },
    components: { 
        menuLeft, mailSide, toTop, vheader
    },
    computed: {
        ...mapState(["messageNo"])
    },
    created(){
        let vm = this;
        vm.checkLogin();
    },
    mounted() {

    },
    methods: {
        ...mapMutations(['MESSAGE_NO','SET_COLLAPSED']),
        refrashStatus(){
            this.$refs.headers.refrashStatus();
        },
        checkLogin(){
            let vm = this, token = GetInfo('token');
            if(!token) {
                vm.$showAlert('请先登录', 'error');
                vm.$router.push({ name: 'login'});
                return;
            }
            // 登陆了查询用户信息
            vm.queryUserInfo();
        },
        hideMail() {
            this.isMail = false;
            this.collapsed = false;
        },
        showMail(){
            this.isMail = true;
            this.collapsed = true;
        },
        hidetion() {
            this.collapsed = false;
        },
        showHandle() {
            this.collapsed = true;
        },
        collapse(){
            this.collapsed = !this.collapsed;
        },
        queryUserInfo(){ // 查询用户基本信息 
            let vm = this;
            API.http({ url: '/merchant/audit_info', type: 'post'}).then(res => {
                if (res.code == 200) {
                    let userInfo = res.data;
                    // 存储必须信息
                    access.session('checkStatusC', vm.checkStatus[String(userInfo.checkStatus)]); //审核状态名称
                    access.session('checkStatus', userInfo.checkStatus); //审核状态
                    access.session('companyName', userInfo.companyName); //公司名称
                    access.session('ystRegisterStep', userInfo.ystRegisterStep); 
                    access.session('newFlag', userInfo.newFlag); //是否为新用户
                    vm.$refs.headers.refrashStatus();
                    return;
                }
            })
        },
    },
}

</script>

<style lang="scss">
@import '../../style/variable';
.m-index {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    padding-top: 71px;
    padding-left: 220px;
    transition: all .3s;
    background: $c9;
    &.menu-collapsed {
        padding-left: 60px;
        .asideNav {
            width: 60px;
        }
    }
    
    .asideNav {
        z-index: 98;
        width: 220px;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        background-color: #1c2d3b;
        overflow: hidden;
        transition: all .3s;
        .logo {
            position: absolute;
            height: 70px;
            top: 0;
            left: 0;
            box-sizing: border-box;
            background: #1c2d3b;
            overflow: hidden;
            z-index: 99;
            width: 220px;
            transition: all .3s;
            -webkit-box-shadow: -10px 2px 10px 4px rgba(21, 33, 43, 0.26);
            box-shadow: -10px 2px 10px 4px rgba(21, 33, 43, 0.26);
            a {
                display: block;
                height: 100%;
                position: relative;
                padding: 20px 0;
                text-align: center;
            }
            img {
                transition: all .3s linear;
                width: 156px;
                height: auto;
            }
        }
        .logo-collapse {
            transition: all .3s;
            width: 60px;
            a {
                img {
                    position: relative;
                    left: 18px;
                    transition: all .3s linear;
                }
            }
        }
    }
    .el-scrollbar__view {
        // height: 100%;
    }
    .content-container {
        //视图内容
        padding: 20px;
        min-width: 1100px;
        // height: 100%;
    }
    #loader {
        &.out {
            transform: rotate(180deg);
        }
        z-index: 9999;
    }
}

.navHover:hover {
    background-color: $c8;
}



.notificationRB {
    background: #45c0a7;
    color: $c1;
    padding: 0;
    .el-notification__group {
        padding: 10px 15px;
        display: block;
        margin-left: 0;
        width: 280px;
    }
    .el-notification__title {
        color: $c1
    }
    .el-notification__title:before {
        content: url("../../assets/img/icon/email.png");
        margin-right: 10px;
        margin-top: 2px;
    }
    .el-notification__content {
        p:first-child {
            color: $c1;
            margin-left: 16px;
            a {
                color: $c1;
                width: 270px;
                display: inline-block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            a:hover {
                text-decoration: underline;
                cursor: pointer;
            }
        }
        p:last-child {
            color: $c1;
            margin-left: 16px
        }
    }
}

.el-menu--vertical {
    left: 58px !important;
    .el-menu {
        background: none;
        &>.el-menu-item-group {
            border-radius: 4px;
            overflow: hidden;
            width: 180px;
            li {
                height: 36px;
                line-height: 36px;
            }
        }
    }
    .el-menu-item {
        background-color: #15212B;
        color: #8892A1;
    }
    .el-menu-item:hover {
        background: $c4;
        color: $c1;
    }
    .el-menu--popup {
        padding: 0;
        min-width: auto;
    }
    .el-submenu {
        background-color: #15212B;
        .el-submenu__title {
            color: #8892A1;
        }
        .el-submenu__title:hover {
            background: $c4;
            color: $c1 !important;
        }
    }
    .el-menu--vertical {
        left: 241px !important;
    }
}
.el-popper {
    margin-top: 1px !important;
}
.el-popover.cityPopper {
    background: rgba($color: #000000, $alpha: 0.3);
    height: 100%;
    z-index: 101 !important;
    left: 0 !important;
    right: 0 !important;
    margin-left: 60px;
    top: 70px !important;
    padding: 0 !important;
    border-top: solid 1px #e7eaec;
    border-bottom: solid 1px #e7eaec;
    box-shadow: none;
    .popper__arrow {
        // border: 1px solid red;
        display: none;
    }
    
}

.el-popover.phonePopver {
    top: 80px !important;
    right: 0 !important;
    z-index: 996 !important;
    padding: 0 !important;
    width: 132px;
    height: 164px;
    background-color: $c1;
    border: solid 1px #dcdfe6;
}

.el-popover.userPopver {
    top: 76px !important;
    right: 0 !important;
    padding: 0 !important;
    width: 170px;
    height: 187px;
    background-color: $c1;
    border: solid 1px #dcdfe6;
    box-shadow: none;
}



.el-menu--vertical .el-submenu .el-submenu__title {
    height: 36px;
    line-height: 36px;
}

.el-menu--collapse {
    width: 60px;
}

.image {
    width: 100%;
    display: block;
}




//cascader样式部分
.m-index .cascader {
    line-height: 70px;
    transition: all 0.5s ease-in;
    .el-cascader {
        background: #15212b
    }
    .el-input__inner {
        height: 36px;
        color: #A6B1C2;
        line-height: 36px;
        width: 36px;
        background: rgba(28, 45, 59, 1);
        border-radius: 18px;
        border: none;
        transition: all 0.5s ease-in;
    }
    .el-input__inner::-webkit-input-placeholder {
        color: #76838E;
        display: inline-block
    }
    .el-input__suffix {
        opacity: 0
    }
    .el-input--suffix .el-input__inner {
        padding-right: 0;
        background: url('../../assets/img/icon/search.png') left center no-repeat;
        height: 36px;
        width: 36px;
        padding-left: 40px;
    }
    .el-cascader__label,
    .el-cascader__label span {
        color: $c1;
    }
    .el-cascader__label {
        padding-left: 36px;
        display: inline-block
    }
}
.m-index .cascader:hover {
    .el-input__inner {
        border: 1px solid rgba(69, 195, 204, 1) !important;
        width: 486px !important;
    }
    .el-input--suffix .el-input__inner {
        padding-right: 0;
        background: url('../../assets/img/icon/searchhover.png') left center no-repeat;
        height: 36px;
        width: 36px;
    }
    .el-input__suffix {
        opacity: 1 !important
    }
}
.cascaderClass {
    .el-cascader-menu__item {
        border: none;
        border-radius: 4px;
        color: #A6B1C2;
        max-width: 160px;
    }
    .el-cascader-menu__item:hover {
        background-color: #1C2D3B;
        color: #45C3CC;
    }
    .el-cascader-menu__item.is-active {
        color: #45C3CC !important;
    }
    .popper__arrow {
        display: none
    }
    .el-cascader-menu__item__keyword {
        color: #45C3CC;
        font-weight: 500;
    }
    ::-webkit-scrollbar {
        width: 5px;
        background: rgba(88, 117, 141, 0.3);
        border-radius: 50px;
    }
    ::-webkit-scrollbar-thumb {
        background: rgba(88, 117, 141, 1);
        border-radius: 4px;
    }
    .el-cascader-menu {
        border: 1px solid #374550;
    }
    .el-cascader-menu--flexible .el-cascader-menu__item {
        width: 100%;
        max-width: none
    }
    .el-cascader-menu__item.is-disabled {
        background-color: #1C2D3B !important;
        border-radius: 4px;
    }
    .el-cascader-menu__item.is-disabled {
        background-color: #1C2D3B !important
    }
}

.cascaderClass.el-cascader-menus {
    background: none;
    border: none;
    border-radius: 4px;
}
.cascaderClass .el-cascader-menu__item:focus:not(:active),
.cascaderClass .el-cascader-menu__item:hover,
.cascaderClass .el-cascader-menus.el-popper .el-carousel__mask,
.cascaderClass .el-cascader-menu,
.cascaderClass .el-cascader-menu__item.is-disabled:hover,
.el-collapse-item__header,
.el-collapse-item__wrap {
    background-color: #1C2D3B
}
.cascaderClass .el-cascader-menu__item:hover {
    background-color: #223647
}


</style>
